import './AppBar.scss';

import React from 'react';
import { useTranslation } from 'src/i18n';

export default function AppBar () {
  const { t } = useTranslation();

  return (
    <div data-testid='app-bar' className='app-bar app-bar-admin'>
      <div className='app-bar-container'>
        <div className='app-bar-main'>
          <span className='admin-title-text'>{t('admin.portal')} </span>
        </div>
      </div>
    </div>
  );
}
